module.exports = __webpack_public_path__ + "img/mision.c85d6b46.svg";